import { Component } from 'react';
import { Flow } from 'flow-react';
import { observer } from "mobx-react"
import { Container, Row, Col} from 'react-bootstrap';
import './Searchinp.css';


const Searchinp = observer(
  class Searchinp extends Component {
	
		state = {fulltextterm:''};
		
		componentDidMount  = () => {
			this.setState({fulltextterm: this.props.fulltextterm});
		}


		handleSubmit = (ev) => {
			ev.preventDefault();
			this.props.setcritcb({fulltext:this.state.fulltextterm});
		}
		
		handlekeys = (ev) => {
			if(ev.keyCode == 13) {
				let v = ev.target.value;
				this.props.setcritcb({fulltext:v});
			}
			else this.setState({fulltextterm: ev.target.value});
		} 
			
    render() {
			return  (
				<form onSubmit={this.handleSubmit}>
					<Col  key={this.props.fulltextterm} className="searchinpcol" xs={12}>
						<div className="searchinputicon" />
						<input id="mainsearchinput" defaultValue={this.props.fulltextterm} onChange={this.handlekeys} placeholder="Rechercher un programme" type="text" className="searchinput" />
					</Col>
				</form>
			)
    }
		
		
		
  }
)


export default Flow.injectFlow(Searchinp);